import { render } from "./PointOfInterest.vue?vue&type=template&id=61271cb1&scoped=true"
import script from "./PointOfInterest.vue?vue&type=script&lang=js"
export * from "./PointOfInterest.vue?vue&type=script&lang=js"

import "./PointOfInterest.vue?vue&type=style&index=0&id=61271cb1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61271cb1"]])

export default __exports__